/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Icon from 'design-framework/common/ui/Icon'
import LeftArrow from 'design-framework/common/icons/prev-arrow.svg'
import RightArrow from 'design-framework/common/icons/next-arrow.svg'
import Slider from 'react-slick'
import './__carousel.global.less'

const NextArrow = ({ onClick }) => (
	<button className="slick-arrow slick-next" onClick={onClick} type="button">
		<Icon glyph={RightArrow} />
	</button>
)

const PrevArrow = ({ onClick }) => (
	<button className="slick-arrow slick-prev" onClick={onClick} type="button">
		<Icon glyph={LeftArrow} />
	</button>
)

export default class Carousel extends Component {
	render() {
		const { children, additionalCarouselOptions } = this.props

		const slidesToShow =
			additionalCarouselOptions.slidesToShow > children.length
				? additionalCarouselOptions.slidesToShow
				: children.length

		const settings = {
			nextArrow: <NextArrow />,
			prevArrow: <PrevArrow />,
			pauseOnHover: true,
			infinite: true,
			speed: 500,
			slidesToShow,
			...additionalCarouselOptions,
		}

		return (
			<div className="slider-container" style={{ height: '100%' }}>
				<Slider {...settings}>{children}</Slider>
			</div>
		)
	}
}

Carousel.propTypes = {
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
		.isRequired,
	additionalCarouselOptions: PropTypes.object,
}

Carousel.defaultProps = {
	additionalCarouselOptions: {
		variableWidth: true,
		autoplay: true,
		centerPadding: 5,
		slidesToShow: 2,
	},
}
